import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

export default function NextUpCard({ week }) {
  if (!week) return null;
  return (
    <div className="bg-slate-900 text-white rounded-3xl p-6 border border-slate-900 shadow-sm" data-testid="next-up-card">
      <div className="flex items-center gap-2 mb-3">
        <span className="text-[11px] font-bold tracking-wider uppercase bg-white/10 px-2 py-1 rounded-full">
          Next Up · Week {week.week_num}
        </span>
      </div>
      <h3 className="font-outfit font-bold text-2xl leading-tight">{week.title}</h3>
      <p className="font-caveat text-xl text-yellow-300 mt-1">{week.tagline}</p>
      <p className="text-sm text-white/70 mt-3 line-clamp-3">{week.core_concept}</p>
      <Link
        to={`/week/${week.week_num}`}
        data-testid="nextup-open-link"
        className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-yellow-300 hover:text-yellow-400"
      >
        Peek at next week <ArrowRight weight="bold" size={16} />
      </Link>
    </div>
  );
}
